// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__8lPvE","active":"NavigationItem_active__2xMeo","NavigationItemIcon":"NavigationItem_NavigationItemIcon__rwXI0"};